module.exports = __webpack_public_path__ + "static/img/accuracy.8cbf49e0.png";